'use client';

import { useMedia } from 'react-use';

import { useTranslations } from 'next-intl';

import { breakpoints } from '@/app.config';

import { useFilterMovieContext } from '@/views/FilteredMoviesView/contexts/useFilterMovieContext';

import { Modal, ModalProps } from '@/components/Modal';

import styles from '@/views/FilteredMoviesView/FiltersModal.module.scss';
import { useSearchParams } from 'next/navigation';

// =================================================================

export const FiltersModal = (props: ModalProps) => {
  const isExtraLarge = useMedia(breakpoints.extraLarge, true);
  const { children, onClose, ...rest } = props;

  const { onReset } = useFilterMovieContext();
  const searchParams = useSearchParams();

  const t = useTranslations('common');

  if (isExtraLarge) return null;

  return (
    <Modal {...rest} onClose={onClose} className={styles.filtersModal}>
      <Modal.Header className={styles.filtersHeader} onClose={onClose}>
        <div className={styles.filterTop}>
          <button
            onClick={onReset}
            className={styles.filtersButton}
            disabled={searchParams.size === 0}
          >
            {t('drop')}
          </button>
        </div>
      </Modal.Header>
      <Modal.Body className={styles.filtersBody}>{children}</Modal.Body>
    </Modal>
  );
};
